// import _ from 'lodash'
import { request } from '../utils/http'

export const REQUEST_OPTIONS = 'options/REQUEST_OPTIONS'
export const GET_OPTIONS = 'options/GET_OPTIONS'
export const REQUEST_FAILED = 'options/REQUEST_FAILED'

let initialState = {
    fetching: false,
    options: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_OPTIONS:
            return {
                ...state,
                fetching: true
            }

        case GET_OPTIONS:
            return {
                ...state,
                options: {
                    ...state.options,
                    [action.model]: {
                        data: action.payload,
                        url: action.url
                    }
                },
                fetching: false
            }

        case REQUEST_FAILED:
            return {
                ...state,
                fetching: false
            }

        default:
            return state
    }
}

export const getOptions = (url, model, callback) => {
    return (dispatch, getState) => {
        dispatch({
            type: REQUEST_OPTIONS
        })

        const state = getState()
        const { options: { options } } = state

        if (options[model]) {
            if (options[model].url === url) {
                return callback({data: options[model].data, msg: "Options already fetched"})
            }
        }
        else{
            request(`${url}`)
        .then(response => {
            dispatch({
                type: GET_OPTIONS,
                payload: response.data || [],
                url: url,
                model: model
            })
            return callback({ data: response.data || [] , msg: 'Get request was required' } )
        })
        .catch(error => {
            dispatch({
                type: REQUEST_FAILED,
                model: 'error',
                payload: [],
                msg: error.message
            })
        })
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/options.js